import styled from '@emotion/styled';

// Component Definition
const NavContainer = styled.div(({ theme }) => ({
  height: '100%',
  padding: '0',

  [theme.components.mediaQueries.sm.max]: {
    padding: 0,
  },
}));

export default NavContainer;
